import type { ReactElement } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { canAccessPlatformAdmin } from '@/components/auth/platformAdminAccess';
import { useMaintenance } from '@/app/providers/MaintenanceProvider';
import { MAINTENANCE_HUB_IDS, type MaintenanceHubId } from '@/services/maintenanceState';
import { HubMaintenancePage } from './HubMaintenancePage';

export function HubMaintenanceGate({
  hubId,
  children,
}: {
  hubId: string;
  children: ReactElement;
}) {
  const { state, availability } = useMaintenance();
  const { user, isAdmin, isPlatformAdmin, isSuperAdmin } = useAuth();
  if (!MAINTENANCE_HUB_IDS.includes(hubId as MaintenanceHubId)) return children;
  const maintenanceHubId = hubId as MaintenanceHubId;

  if (availability === 'unknown' || state.global.enabled || !state.hubs[maintenanceHubId].enabled) return children;

  const legacyFallbackEnabled = import.meta.env.VITE_ALLOW_LEGACY_ADMIN_FALLBACK !== 'false';
  const canBypass = canAccessPlatformAdmin({
    platformAccessVerified: user?.platformAccessVerified,
    isSuperAdmin,
    isPlatformAdmin,
    platformAdminAreas: user?.platformAdminAreas,
    isAdmin,
    isLegacyAdmin: user?.isLegacyAdmin,
    legacyFallbackEnabled,
  });

  return canBypass ? children : <HubMaintenancePage hubId={maintenanceHubId} state={state.hubs[maintenanceHubId]} />;
}
